import type { Color, CustomableImage } from "../types"
import { convertColor as utilConvertColor, findCustomableImage as utilFindCustomableImage } from "../utils"

export const CUSTOMABLE_IMAGE_SERVICE = Symbol.for('CUSTOMABLE_IMAGE_SERVICE')

export interface CustomableImageService {
  convertColor(strColor: any): Color | undefined
  findCustomableImage(color: Color, customableImage: CustomableImage): string
}


export class DefaultCustomableImageService implements CustomableImageService {
  findCustomableImage(color: Color, customableImage: CustomableImage): string {
    return utilFindCustomableImage(color, customableImage)
  }

  convertColor(strColor: any): Color | undefined {
    return utilConvertColor(strColor)
  }
}
